import { render, staticRenderFns } from "./SpotifyConnect.vue?vue&type=template&id=84539198&"
import script from "./SpotifyConnect.vue?vue&type=script&lang=ts&"
export * from "./SpotifyConnect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports